export default function IconGemstone({
  className,
}: {
  className?: string;
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={className}
    >
      <path
        d="M12 22L11.4049 22.4564L12 23.2324L12.5951 22.4564L12 22ZM22 8.95997L22.5951 9.41637L22.9498 8.95384L22.5892 8.49593L22 8.95997ZM2 8.95997L1.41079 8.49593L1.05015 8.95384L1.40485 9.41637L2 8.95997ZM18.07 3.96997L18.6592 3.50593L18.434 3.21997H18.07V3.96997ZM5.93 3.96997V3.21997H5.56601L5.34079 3.50593L5.93 3.96997ZM12 22L12.5951 22.4564L22.5951 9.41637L22 8.95997L21.4049 8.50357L11.4049 21.5436L12 22ZM2 8.95997L1.40485 9.41637L11.4049 22.4564L12 22L12.5951 21.5436L2.59515 8.50357L2 8.95997ZM12 22H12.75V8.95997H12H11.25V22H12ZM12 8.95997L12.4763 9.53933L18.5463 4.54933L18.07 3.96997L17.5937 3.39061L11.5237 8.38061L12 8.95997ZM18.07 3.96997L17.4808 4.43401L21.4108 9.42401L22 8.95997L22.5892 8.49593L18.6592 3.50593L18.07 3.96997ZM22 8.95997V8.20997H12V8.95997V9.70997H22V8.95997ZM12 8.95997V8.20997H2V8.95997V9.70997H12V8.95997ZM2 8.95997L2.58921 9.42401L6.51921 4.43401L5.93 3.96997L5.34079 3.50593L1.41079 8.49593L2 8.95997ZM5.93 3.96997L5.45372 4.54933L11.5237 9.53933L12 8.95997L12.4763 8.38061L6.40628 3.39061L5.93 3.96997ZM5.93 3.96997V4.71997H18.07V3.96997V3.21997H5.93V3.96997Z"
        fill="currentColor"
      />
    </svg>
  );
}
